import 'lazysizes'
import './common'
import './lib/listing-detail-copy'
import { initializeListingTeasers } from './components/listing-teaser'
import { AccordionSection } from './components/section-accordion'
import { ListingsSection } from './components/section-listings'
import { Header } from './components/header'
import { AuthSection } from './components/section-auth'

// Initialize (first) listings section
const $listings = document.querySelector('.section-listings') as HTMLElement | null
if ($listings !== null) {
  new ListingsSection($listings)
}

// Initialize header
const $header = document.querySelector('.header') as HTMLElement | null
if ($header !== null) {
  new Header($header)
}

// Initialize accordion sections
const $accordions = document.querySelectorAll('.section-accordion') as NodeListOf<HTMLElement>
for (const $accordion of $accordions) {
  new AccordionSection($accordion)
}

// Replace teaser links by showing a dialog
initializeListingTeasers()

const $authSections = document.querySelectorAll('[data-section-auth]') as NodeListOf<HTMLElement>
for (const $authSection of $authSections) {
  new AuthSection($authSection)
}
